// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { quickOrderSearchStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    container: { gap: 30 },
    searchGridItem: { width: [12, 12, 5, 5, 6] },
    unitOfMeasureGridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
    qtyGridItem: { width: [4, 4, 4, 2, 2], align: "middle" },
    buttonGridItem: { width: [8, 8, 6, 6, 6] },
    selectButton: {
        css: css`
            width: 100%;
            align-self: flex-end;
        `,
    },
    clearIcon: {
        css: css`
            position: absolute;
            right: 45px;
            top: 30px;
            cursor: pointer;
        `,
    },
    searchDynamicDropdown: {
        cssOverrides: {
            selectedText: css`
                padding-right: 55px;
            `,
        }
    },
};
